export function modifierClass (className) {
    return '-' + className;
}
